import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as ReloadSvg } from 'assets/images/common/reload.svg';

const rotateStyle = css`
    animation: rotate 1s linear infinite;
    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

const Reload = styled(ReloadSvg)<{ spin?: boolean }>`
    ${({ spin }) => spin && rotateStyle}
`;

export const StyledIconWrapper = styled.div<{
    type?: 'normal' | 'success' | 'outline';
    background?: string;
    color?: string;
    size?: number;
    asButton?: boolean;
}>`
    border-radius: 50%;
    color: ${({ color, type, theme }) => (type === 'outline' ? theme.c.primary01 : color || '#000')};
    background-color: ${({ type, theme }) =>
        type === 'success' ? theme.c.success : type === 'outline' ? 'unset' : theme.c.primary01};
    background-color: ${({ background }) => background};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${({ size }) => `${size || 16}px`};
    height: ${({ size }) => `${size || 16}px`};

    ${({ asButton }) =>
        asButton
            ? `
        cursor: pointer;
            &:not(:disabled):hover,
            &:not(:disabled):focus,
            &:not(:disabled):active {
                filter: brightness(0.85);
            }
    `
            : undefined};
`;

type IconProps = {
    background?: string;
    color?: string;
    size?: number;
    borderRadius?: string;
    padding?: string;
    style?: any;
    spin?: boolean;
    onClick?: () => void;
    type?: 'normal' | 'success' | 'outline';
};

export const ReloadIcon = ({ style, size = 16, onClick, spin, ...rest }: IconProps) => {
    const handleClick = () => {
        if (spin) {
            return;
        }
        onClick?.();
    };
    return (
        <StyledIconWrapper asButton {...rest} size={size} style={style} onClick={handleClick}>
            <Reload width={size - 6} height={size - 6} spin={spin} {...rest} />
        </StyledIconWrapper>
    );
};
